import { useEffect } from 'react';

const BASE_TITLE = 'Zolaid';

function setMeta(attrName, attrValue, value) {
  const el = document.querySelector(`meta[${attrName}="${attrValue}"]`);
  if (el) el.setAttribute('content', value);
}

/**
 * Sets document.title when the component mounts. Use once per route/page.
 * Optional `description` updates meta description + Open Graph / Twitter cards for SEO.
 */
export default function DocumentTitle({ title, description }) {
  useEffect(() => {
    const previousTitle = document.title;
    const fullTitle = title ? `${title} | ${BASE_TITLE}` : BASE_TITLE;
    document.title = fullTitle;

    const prev = {};
    const restore = [];

    if (description) {
      const pairs = [
        ['name', 'description'],
        ['property', 'og:title'],
        ['property', 'og:description'],
        ['name', 'twitter:title'],
        ['name', 'twitter:description'],
      ];
      for (const [attr, key] of pairs) {
        const el = document.querySelector(`meta[${attr}="${key}"]`);
        if (el) {
          restore.push({ el, value: el.getAttribute('content') });
        }
      }
      setMeta('name', 'description', description);
      setMeta('property', 'og:title', fullTitle);
      setMeta('property', 'og:description', description);
      setMeta('name', 'twitter:title', fullTitle);
      setMeta('name', 'twitter:description', description);
    }

    return () => {
      document.title = previousTitle;
      restore.forEach(({ el, value }) => {
        if (el) el.setAttribute('content', value || '');
      });
    };
  }, [title, description]);
  return null;
}
